import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { IData } from './types';
import App from './App';
import { FormProvider } from './components/contexts/form';

const elements = document.querySelectorAll('.app-calculator');
elements.forEach((element) => {
	const root = createRoot(element);

	const apiBase = element.getAttribute('data-api-base') ?? '';
	const calculatorKey = element.getAttribute('data-calculator-key') ?? '';
	const calcFields = element.getAttribute('data-calc-fields') ?? '';
	const resultHeadings = element.getAttribute('data-result-headings') ?? '';
	const calcHeading = element.getAttribute('data-calc-heading') ?? '';
	const resultHeading = element.getAttribute('data-result-heading') ?? '';
	const showResults = element.getAttribute('data-show-results') === 'true';

	const data: IData = {
		apiBase,
		calculatorKey,
		calcFields: JSON.parse(calcFields),
		resultHeadings: JSON.parse(resultHeadings),
		calcHeading,
		resultHeading,
		showResults,
	};

	root.render(
		<React.StrictMode>
			<FormProvider>
				<App {...data} />
			</FormProvider>
		</React.StrictMode>
	);
});
